import { useMemo, useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { useWindowDimensions, YStack } from 'smoothie';

import type { IBill } from '../../types/Bill';
import BillBubbles from './BillBubbles';

interface HeaderComponentProps {
    bills: IBill[];
}

export const BillHeaderBubbles = ({ bills }: HeaderComponentProps) => {
    const [totalHeight, setTotalHeight] = useState(0);

    // we need to know the height available for the category bubbles
    const bubblesHeight = useMemo(() => {
        if (totalHeight > 0) {
            return totalHeight;
        }

        return 0;
    }, [totalHeight]);

    const onTotalLayout = (e: LayoutChangeEvent) => {
        setTotalHeight(e.nativeEvent.layout.height);
    };

    const dimensions = useWindowDimensions();

    const billAmountsByCategory = bills.reduce<Record<string, number>>(
        (acc, bill) => {
            const currentTotal = acc[bill.category] ?? 0;
            return {
                ...acc,
                [bill.category]: currentTotal + bill.monthlyAmount,
            };
        },
        {},
    );

    const predeterminedHeight = dimensions.height * 0.4;

    return (
        <YStack
            onLayout={onTotalLayout}
            width="100%"
            height={predeterminedHeight}
            alignItems="center"
            flexGrow={1}
            gap={20}
        >
            {bubblesHeight > 0 && (
                <BillBubbles
                    billAmountsByCategory={billAmountsByCategory}
                    containerHeight={predeterminedHeight}
                />
            )}
        </YStack>
    );
};
